<script>
  import { _ } from "svelte-i18n";
  import { isLoading } from "svelte-i18n";
  import { register, init, getLocaleFromNavigator } from "svelte-i18n";

  import config from "../config.js";
  import Diary from "./Diary.svelte";
  import Calendar from "./Calendar.svelte";

  register("fr", () => import("/i18n/fr.js"));
  register("en", () => import("/i18n/en.js"));

  const locale = getLocaleFromNavigator().split("-")[0];
  init({
    fallbackLocale: "en-GB",
    initialLocale: locale,
  });

  const db = new PouchDB(config.dbName);
  let presentation = displayPresentation();

  let activeDiary = null;
  let activeMonth = moment().month();
  let activeYear = moment().year();
  let activeModule = "calendar";

  let calendar = null;

  let foodDiaries = {};
  let foodIntolerances = [];

  const noop = () => {};

  function displayPresentation() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);

    if (!check) {
      if (localStorage.getItem("accessPCVersion"))
        check = localStorage.getItem("accessPCVersion") === "true";
      else check = false;
    }

    return check;
  }

  function getPresentationImageSrc(index) {
    return "images/pres_image" + index + "_" + locale.split("-")[0] + ".jpg";
  }

  function logError(err, response) {
    if (err) {
      return console.log(err);
    } else if (response) {
      return console.log(response);
    }
  }

  function computeFoodIntolerances() {
    let badIngredients = [];
    let goodIngredients = [];
    Object.values(foodDiaries).forEach((diaries) => {
      Object.values(diaries).forEach((diary) => {
        if (diary.feeling && diary.ingredients.length) {
          if (diary.feeling !== "good") {
            badIngredients.push(diary.ingredients);
          } else {
            goodIngredients.push(diary.ingredients);
          }
        }
      });
    });

    badIngredients = [...new Set([].concat.apply([], badIngredients))];
    goodIngredients = [...new Set([].concat.apply([], goodIngredients))];
    foodIntolerances = badIngredients.filter(
      (ingredient) => !goodIngredients.includes(ingredient)
    );

    if (!calendar) return;
    if (!foodIntolerances || !Object.values(foodIntolerances).length)
      foodIntolerances = [];

    calendar.intolerances = foodIntolerances;
    calendar.fillIntolerances();
  }

  function extractDiarisFromRows(rows) {
    rows.forEach((row) => {
      let newDiary = {};

      const date = moment(row._id.split("diary_")[1].replace(/\_/g, "-"));
      const index = date.format("YYYY_MM_DD");
      foodDiaries[index] = row;
      foodDiaries[index].date = date.format("YYYY-MM-DD");
    });

    if (!foodDiaries || !Object.values(foodDiaries).length) foodDiaries = {};

    calendar.diaries = foodDiaries;
    calendar.fillCalendar();

    computeFoodIntolerances();
  }

  function getDiaries() {
    db.allDocs(
      {
        include_docs: true,
        startkey: "diary",
        endkey: "diary\ufff0",
      },
      (err, response) => {
        const rows = response.rows.map((row) => row.doc);
        extractDiarisFromRows(rows);
      }
    );
  }

  function removeAllDiaries() {
    return db.allDocs().then(function (result) {
      return Promise.all(
        result.rows.map(function (row) {
          return db.remove(row.id, row.value.rev);
        })
      );
    });
  }

  function uploadFoodDiaries(event) {
    removeAllDiaries()
      .then(() => {
        foodDiaries = {};
        const uploadedDiaries = event.detail.uploadedDiaries;
        Object.values(uploadedDiaries).forEach((diary) => delete diary._rev);

        foodDiaries = uploadedDiaries;
        Object.values(foodDiaries).forEach((fooddiary) => {
          db.put(fooddiary, (err, response) => {
            if (err) {
              console.log(err);
            } else {
              fooddiary._rev = response.rev;
            }
          });
        });

        calendar.diaries = foodDiaries;
        calendar.fillCalendar();
        computeFoodIntolerances();
      })
      .catch(function (err) {
        console.log(error);
      });
  }

  function clearDiaries() {
    removeAllDiaries()
      .then(() => {
        foodDiaries = {};
        foodIntolerances = [];

        calendar.diaries = foodDiaries;
        calendar.intolerances = foodIntolerances;
        calendar.fillCalendar();
        calendar.fillIntolerances();
      })
      .catch(function (err) {
        console.log(error);
      });
  }

  function calendarLoaded(event) {
    getDiaries();
  }

  function switchModule(event) {
    activeModule = event.detail.newModule;

    const date = moment(event.detail.activeDate);
    const activeIndex = date.format("YYYY_MM_DD");

    if (event.detail.diaryRemoved) {
      delete foodDiaries[event.detail.diaryRemoved];
    }

    if (event.detail.openDiary) {
      const index = event.detail.openDiary;
      activeDiary = foodDiaries[index] || {};
      if (!activeDiary._id) {
        activeDiary.date = date.format("YYYY-MM-DD");
        foodDiaries[index] = activeDiary;
      }
    }

    activeMonth = date.month();
    activeYear = date.year();
  }

  function accessPC() {
    presentation = false;
    localStorage.setItem("accessPCVersion", true);
    document.location.reload(true);
  }
</script>

<style>
  #header {
    width: 100%;
    padding: 2.5% 0 0 0;
  }

  h1 {
    display: inline-block;
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: 3vw;
    font-weight: 600;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 5px;
    vertical-align: middle;
    color: var(--foreground-color);
  }

  .hr {
    width: 70%;
    height: 2px;
    margin: 2.5% auto;
    background-color: var(--border-color);
  }

  .infos {
    display: block;
    width: 60%;
    margin: 2% auto 0.5% auto;
    font-size: 2vw;
    line-height: 2vw;
    font-style: italic;
    text-align: center;
    color: var(--infos-color);
  }

  .infos2 {
    margin: 0.5% auto 2% auto;
    font-style: normal;
    border: 0;
    outline: 0;
    background: none;
    cursor: pointer;
    color: var(--foreground-color);
  }

  .infos2:hover {
    text-decoration: underline;
  }

  .presentation {
    display: block;
    width: 80%;
    margin: 0 auto;
  }

  .presentation .image {
    width: 18%;
    height: auto;
    margin: 0 3.5%;
    border-radius: 5px;
    border: 1px solid var(--infos-color);
  }

  #footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 1% 0 0.5% 0;
    width: 100%;
    height: auto;
  }
  p,
  #footer :global(a) {
    width: auto;
    color: var(--main-text-color);
    text-align: center;
    font-size: 1.1vw;
  }
  #footer :global(a) {
    text-decoration: underline;
  }
</style>

{#if $isLoading}
  Please wait...
{:else}
  {#if presentation}
    {#if activeModule === 'diary'}
      <Diary
        {db}
        on:switchModule={switchModule}
        {activeDiary}
        {activeMonth}
        {activeYear} />
    {:else}
      <Calendar
        bind:this={calendar}
        on:switchModule={switchModule}
        on:uploadFoodDiaries={uploadFoodDiaries}
        on:clearDiaries={clearDiaries}
        on:calendarLoaded={calendarLoaded}
        {activeMonth}
        {activeYear} />
    {/if}
  {:else}
    <div id="header">
      <h1 id="title">{$_('app.title')}</h1>
    </div>

    <div class="hr" />

    <p class="infos">{$_('app.infos1')}</p>
    <button
      class="infos infos2"
      on:click={() => accessPC()}>{$_('app.infos2')}</button>

    <div class="presentation">
      <img
        class="image"
        src={getPresentationImageSrc(1)}
        alt="Presentation image 1" />
      <img
        class="image"
        src={getPresentationImageSrc(2)}
        alt="Presentation image 2" />
      <img
        class="image"
        src={getPresentationImageSrc(3)}
        alt="Presentation image 3" />
      <img
        class="image"
        src={getPresentationImageSrc(4)}
        alt="Presentation image 4" />
    </div>

    <footer id="footer">
      <p>
        {@html $_('app.copyright')}
      </p>
    </footer>
  {/if}
{/if}
